import { Button, Stack } from '@lyearn/ui';

import { DialogFooterProps } from './types';

const DialogFooter = (props: DialogFooterProps) => {
  const {
    className = 'p-24',
    autoFocus = true,
    gapX = 8,
    buttonSize = 'large',
    primaryAction,
    secondaryAction,
  } = props;

  return (
    <Stack className={className} direction="row-reverse" gapX={gapX}>
      <Button autoFocus={autoFocus} shape="pill" size={buttonSize} {...primaryAction}>
        {primaryAction.label}
      </Button>
      {secondaryAction ? (
        <Button
          appearance="secondary"
          shape="pill"
          size={buttonSize}
          variant="outlined"
          {...secondaryAction}>
          {secondaryAction.label}
        </Button>
      ) : null}
    </Stack>
  );
};

export default DialogFooter;
